import {
  Directive,
  ElementRef,
  Renderer2,
  OnDestroy,
  AfterViewInit
} from '@angular/core'

@Directive({
  selector: '[autoscaleTextRumor]'
})
export class AutoscaleTextRumorDirective implements AfterViewInit, OnDestroy {
    private resizeObserver: ResizeObserver | undefined
    private minFontSize = 12
    private maxFontSize = 25
    private step = 1

    constructor(private el: ElementRef, private renderer: Renderer2) {}

    ngAfterViewInit(): void {
        this.resizeText()

        this.resizeObserver = new ResizeObserver(() => {
            this.resizeText()
        })

        if (this.el.nativeElement?.parentElement) this.resizeObserver.observe(this.el.nativeElement.parentElement)
    }

    ngOnDestroy(): void {
        if (this.resizeObserver) this.resizeObserver.disconnect()
    }

    private resizeText(): void {
        const element = this.el.nativeElement as HTMLElement
        const container = element.parentElement as HTMLElement
        if (!container) return

        let fontSize = this.maxFontSize
        element.style.setProperty('white-space', 'nowrap', 'important')
        element.style.setProperty('overflow', 'hidden', 'important')
        element.style.setProperty('font-size', `${fontSize}px`, 'important')

        while (fontSize > this.minFontSize && element.scrollWidth > container.clientWidth) {
            fontSize -= this.step
            element.style.setProperty('font-size', `${fontSize}px`, 'important')
        }
        
        fontSize -= this.step
        element.style.setProperty('font-size', `${fontSize}px`, 'important')
    }
}